import React from 'react';
import AMV2AssetSelector from './AMV2AssetSelector';
import cbModal from '../Modal/Modal';
import { ModalProps } from '../Modal/Modal';
import { AMV2AssetPickerArgs, AMV2MoveTargetArgs } from './utils/types';

const openAMV2MoveTargetModal = (args: AMV2MoveTargetArgs, modalProps?: ModalProps) => {
  const enhancedModalProps: ModalProps = {
    ...modalProps,
    size: 'large',
    customClass: modalProps?.customClass
      ? modalProps.customClass
      : 'AssetFieldModal-wide-popup V2-select-wide-popup MoveTargetModal'
  };

  const moveArgs: AMV2AssetPickerArgs = {
    ...args,
    mode: 'moveTarget',
    hideStackAssetsSwitch: true,
    isVariantPlanEnabled: () => false,
  };

  cbModal({
    component: props => (
      <AMV2AssetSelector
        {...props}
        {...moveArgs}
      />
    ),
    modalProps: enhancedModalProps
  });
};

export default openAMV2MoveTargetModal;
